import { render, staticRenderFns } from "./MasterDataStaff.vue?vue&type=template&id=e932eab4&scoped=true"
import script from "./MasterDataStaff.vue?vue&type=script&lang=js"
export * from "./MasterDataStaff.vue?vue&type=script&lang=js"
import style0 from "./MasterDataStaff.vue?vue&type=style&index=0&id=e932eab4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e932eab4",
  null
  
)

export default component.exports